import ReconnectingWebSocket from 'reconnectingwebsocket';
import i18n from '../plugins/language/index';
import store from '../plugins/store/index';
import constants from './constants'
import util from './util'
import newWebRTC from "./new-webrtc"
const logTitle = '---websocket--->'
let socket;

const messageTypes = {
    SUBSCRIBE: 'subscribe',
    CANCEL: 'cancel'
}
const ws = {
    message: {},
    data: {
        waiting: false,
        terminalNames: [],
        events: {},
    },
    playErrorSoundInstance () {
        if (!this.audioTag) {
            this.audioTag = document.createElement('audio');
            this.audioTag.setAttribute('src', '/sounds/error.mp3');
            this.audioTag.setAttribute('type', 'audio/mpeg')
        }
        this.audioTag.play();
    },
    on(eventName, eventHandler, index) {
        if (!this.data.events[eventName]) this.data.events[eventName] = [];
        this.data.events[eventName][index || 0] = eventHandler;
    },
    emit(eventName, data) {
        if (this.data.events[eventName]) this.data.events[eventName].forEach(callback => {
            if (callback) callback(data);
        });
    },
    cancel(eventName, index) {
        if (this.data.events[eventName]) this.data.events[eventName][index] = null;
    },
    //socket.readyState 对应四种状态：0 ：正在建立连接，1：建立成功  2：正在关闭  3：已经关闭
    init(token) {
        var tokenlocalStorage;
        if (socket && socket.readyState !== 3) {
            return;
        }
        if (!token) {
            tokenlocalStorage = localStorage.getItem("token");
        }
        socket = new ReconnectingWebSocket(`${util.websocketURL}/websocket/${tokenlocalStorage.replace(/\//g, "*")}`);
        socket.onopen = this.onOpen;
        socket.onmessage = this.onMessage;
        socket.onclose = this.onClose;
        socket.onerror = this.onError;
    },
    isConnected() {
        return socket && socket.readyState === 1;
    },
    onOpen(e) {
        ws.emit('on-reconnect')
    },
    //接收  服务端主动传来的消息
    onMessage(event) {
        let message; 
        try { 
            message = typeof event.data == 'string' ? JSON.parse(event.data) : event.data;
            this.message = message
            if (message == null) return
        } catch (e) {
            message = event.data; 
        } 
        //  通过message 消息类型（code）  判断不同的消息
        let code = message.code
        let action = message.action
        let data = message.data
        let deviceName = message.deviceName 
        if (code == 200) { 
            if (ws.data.waiting) {
                ws.sendTerminalNames(messageTypes.SUBSCRIBE);
            }
        } else if (code == 201) { 
            store.commit("addFault", message.message);
        }
        if (util.page_monitor) clearTimeout(util.page_monitor.terminalMessageTimer[action]);// 清除定时器，防止污染其他定时
        switch (action) {
            case "return_file_manage":  
           
                if(message.result == "success" && data.and_server_proxy_url){
                    window.open(data.and_server_proxy_url,'_blank')
                } else{ 
                    util.context.$Modal.confirm({
                        title: message.msg, 
                        onOk: (data) => { 
                                 
                        }  
                    })
                } 

               
                break;
            case 'help':  
                util.context.helpWprders = message.data.mt_workers
                util.context.$Modal.confirm({
                    title: i18n.tc('l.warn'),
                    name: 'help',
                    render: (h, param) => {
                        return h('div', [
                            h('h3', message.data.lift_name + ' ' + i18n.tc('l.hint36')),
                            h('h3', i18n.tc('l.occur_time')+ " : " + message.time),
                            h('h3', i18n.tc('l.occur_location')+ " : " + message.data.community_name + message.data.building + message.data.unit),
                        ])
                    },
                    onOk: (data) => { 
                        if(deviceName.startsWith("L_")){  
                            util.ajax.post('/device/sendmqtt', {
                                action: "monitor",
                                data: {},
                                terminal_id: deviceName,
                                token: localStorage.getItem("token")
                              }).then(res => {     
                                 window.open(`${constants.newWebRtcHost}/?roomId=${deviceName}&mode=2&peerId=2_${deviceName}`,'_blank')
                               })                            
                        }else{
                            util.context.$store.commit("callHelp", true)
                            // 先判断是否连接socket
                            if (newWebRTC.socket && newWebRTC.socket.readyState != 3) {// 已连接
                                newWebRTC.socket.close();
                            }
                            newWebRTC.connect({
                                server: 'wss://www.diantiyun.com:3000',
                                room: message.data.room_id,
                                // isMonitor:false,
                                action: "help",
                                device: null
                            })
                        }                    
                    },
                    okText: i18n.tc("l.hint37")
                })
                break;
            case 'up_report_status':
                ws.emit('up_report_status', message);
                ws.emit("updateDeviceStatus",message);
                if (message.data.type == 1) { // 单次
                    if (util.page_monitor) util.page_monitor.modal.params = message.data;
                }
                break;
            case 'U01': // 新版WCR设备  运行状态上报
                console.log("U01====>",message)
                if (message.iecs){
                    ws.emit('up_report_status', message);
                    ws.emit("updateDeviceStatus",message);
                }
                if (message.v === 1) {
                    ws.emit('up_report_status', message);
                    ws.emit("updateDeviceStatus",message);
                    if (message.data.type == 1) { // 单次
                        if (util.page_monitor) {
                            util.page_monitor.modal.params = message.data;
                            util.page_monitor.modal.params["systemTime"] = message.systemTime;
                        }
                    }
                }
                else if (message.v === 2){ // 版本2 需要
                    ws.emit('up_report_status_v2', message);
                }
                break;
            case "U02":// 电梯扩展数据
                util.page_monitor.extensionModal.spinShow = false;
                util.page_monitor.extensionModal.tabPane[message.data.type - 1] = message.data
                // 总运行次数、开关门、运行时间、总运行距离、今日上下行次数、健康度
                if (message.v==2){ // 版本2 需要
                    ws.emit('on_lift_statistics', message);
                }
                break;
            case "return_update_apk": //更新apk 
                if (message.state == 'fail') {
                    util.context.$Notice.error({
                        title: i18n.tc('l.warn'),
                        desc: i18n.tc('l.remark151')
                    })
                } else {
                    util.context.$Notice.success({
                        title: i18n.tc('l.prompt'),
                        desc: i18n.tc('l.remark152')
                    })
                }
                break
            case "return_update":  // 返回更新广告机结果
                if (message.state == 'fail') {
                    var returnResult = message.data
                    util.context.$Notice.close("synchro")
                    for (let s in returnResult) {
                        util.context.$Notice.error({
                            title: i18n.tc('l.error'),
                            desc: constants.failMessageMap[returnResult[s]]
                        })
                    }
                } else {
                    util.context.$Notice.success({
                        title: i18n.tc('l.prompt'),
                        desc: i18n.tc('l.remark152')
                    })
                }
                break;
            case 'list_monitor_config':
                if (ws.onLiftMonitorConfig) ws.onLiftMonitorConfig(data);
                break;
            case 'status_report':
                ws.emit('status_report', message);
                ws.emit('updateIndexData', message.type = "onoff");
                break;
            case 'up_report_fault': // 故障
            case 'U03':
                // util.context.$Notice.destroy();
                // var liftInfo = message.lift_info;
                let liftLocation = util.parseJSON(message.location, {});
                liftLocation.building = liftLocation.building || {name: ''};
                liftLocation.unit = liftLocation.unit || {name: ''};
                liftLocation.door = liftLocation.door || {name: ''};
                let explainObj = JSON.parse(message.explain);
                var address = `${message.community || ''} ${liftLocation.building.name} ${liftLocation.unit.name} ${liftLocation.door.name}`;
                var content = `${i18n.tc('l.lift')}：${message.device}[${message.deviceName}]${address.trim()?'('+address+')':''} 于 ${new Date(message.timestamp).pattern('yyyy-MM-dd HH:mm:ss')} ${i18n.tc('l.occur')}${explainObj.fault_no} ${i18n.tc('l.remark153')}【${explainObj.fault_name}】。${i18n.tc('l.remark154')}。`
                if (localStorage.getItem("close_fault_notice")){ // 关掉页面故障提示
                    util.context.$Notice.error({
                        title: `${i18n.tc('l.lift_fault')} [${message.deviceName}]`,
                        duration: 3,
                        render: h => {
                            var contents = [];
                            contents.push(h('li', [i18n.tc('l.lift_fault')+":", message.device]));
                            contents.push(h('li', [i18n.tc('l.fault')+":", `【${explainObj.fault_no}】 ${explainObj.fault_name}`]));
                            if (address.trim()) contents.push(h('li', [i18n.tc('l.address')+":", address]));
                            contents.push(h('li', [i18n.tc('l.fault_time')+":", new Date(message.timestamp).pattern('yyyy-MM-dd HH:mm:ss')]));
                            contents.push(h('li', [i18n.tc('l.fault_floor')+":", message.floor, message.floor == message.floor_display ? '' : `(${message.floor_display})`]));
                            return h('ul', {
                                style: {
                                    fontWeight: 'bold',
                                    fontSize: '14px'
                                }
                            }, contents)
                        },
                    })
                    ws.playErrorSoundInstance();
                }
                ws.emit('up_report_fault', message);
                ws.emit('up_report_status', message);
                ws.emit("updateIndexData", {type: 'addF'});
                // 播放故障音效
                break;
            case 'up_solve_fault':
            case "U04": // 解决故障
                ws.emit('up_solve_fault', message);
                ws.emit("updateIndexData", {type: 'delF'})
                break;
            case 'return_chat_result':// 是否允许监控或者下载文件
                console.log("return_chat_result====>",message);
                util.context.$Message.destroy();
                if (util.context.timer) clearInterval(util.context.timer)
                if (message.result) {
                    if (message.type == 'monitor') {  // 当前操作=允许监控
                            newWebRTC.connect({
                                server: 'wss://www.diantiyun.com:3000',
                                room: message.deviceName,
                                // isMonitor:true,
                                action: "monitor"
                            });
                    } else {  // 当前操作=允许文件下载
                        if (!newWebRTC.socket || newWebRTC.socket && newWebRTC.socket.readyState == 3) {
                            util.page_monitor.isTerminalJoin = true
                            newWebRTC.connect({
                                server: "wss://www.diantiyun.com:3000",
                                action: "call_file_list",
                                room: util.page_monitor.device.terminal_id,
                                device: util.page_monitor.device,
                                // isMonitor: false
                            })
                        } else {
                            util.page_monitor.isTerminalJoin = false
                        }
                        util.page_monitor.ifShowHistoryMonitor = true
                    }
                } else {
                    if (message.type == 'help') {
                        util.context.$Message.error(i18n.tc('l.remark155'));
                    }
                    else  if(message.type == 'monitor'){
                        util.context.$Message.error(i18n.tc('l.remark156'));
                    }
                    else  if (message.type == 'off_monitor') {
                        util.context.$Message.error(i18n.tc('l.remark196'));
                    }
                }
                break;
            case 'up_report_parameter':// 获取实时运行参数
                util.context.$Message.destroy();
                util.page_monitor.modal.params = message.data;
                util.page_monitor.modal.params["systemTime"] = message.systemTime;
                util.page_monitor.modal.show = true;
                break;
            case 'return_database':// 返回版本升级信息 
                util.context.$Message.destroy();
                var type = message.deviceName.startsWith('T') ||   message.deviceName.startsWith('L') 
           
                if (util.page_monitor.timer_update) clearTimeout(util.page_monitor.timer_update);
                var current_version = type ? parseInt(message.database.apk.version.substring(2, 6)) : parseInt(message.data.apk.version.substring(2, 6)); // 当前
                
                var new_version = parseInt(util.page_monitor.terminalVersion.version.substring(2, 6))//   最新版本
                
                if (current_version >= new_version) {
                    util.context.$Modal.confirm({
                        title: i18n.tc('l.prompt'),
                        content: `${i18n.tc('l.remark158')}${current_version},${i18n.tc('l.remark159')}${new_version}`,
                        okText:  i18n.tc('l.close'),
                    })
                    return;
                }else {

                    let list = []
                    if (type) {
                        list.push(util.page_monitor.device.terminal_id)
                    } else {
                        list.push(util.page_monitor.device.face_id)
                    }
                    util.context.$Modal.confirm({
                        title: i18n.tc('l.prompt'),
                        content: `${i18n.tc('l.remark158')}${current_version},${i18n.tc('l.remark159')}${new_version} ,${i18n.tc('l.remark160')}?`,
                        onOk: (() => { 
                            util.ajax.post('/portal/update', {
                                list: list,
                                new_version: util.page_monitor.terminalVersion,
                                token: localStorage.getItem("token"),
                            }).then((res) => { 
                                if (res.code) {
                                    util.context.$Message.error(i18n.tc('l.remark161'))
                                } else {
                                    util.context.$Notice.success({
                                        title: i18n.tc('l.prompt'),
                                        duration: 1,
                                        desc: i18n.tc('l.remark162')
                                    })
                                }
                            })
                        }),
                    })
                }
                break;
            case "U05":
                ws.emit("main_board_param", message);
                util.page_monitor.mainModal.table.loading = false;
                    if (!message.deviceName.startsWith("E00")&&message.data.status != 2) {
                        util.context.$Message.warning(i18n.tc('l.remark163'))
                    }
                break;
            case "U06":
                if (message.data.status == 2) {
                    util.context.$Message.success(i18n.tc('l.success'))
                } else {
                    util.context.$Message.error(i18n.tc('l.fail'))
                }
                break;
            case "U07":
                break;
            case "U08":
            case "U09":
                ws.emit("terminal_param_setting", message);
                break;
            case "U0A":
                let byteU0A = JSON.parse(message.data); // 是否成功 2--成功 1 -- 校验 / 1：远程梯控 2：远程停梯 3：解除停梯 4：远程迫降 5：远程锁梯 6：解除锁梯 7：远程修改密码周期
                if (byteU0A[0] == 1) {
                    util.context.$Message.error(i18n.tc('l.remark164'))
                }
                break;
            // case "U0B": // 返回最后一包数据更新电梯的状态信息
            //     ws.emit('updateDeviceStatus', message);
            //     break;
            case "forced_offline":
                //跳转到登录页面，密码修改了
                if (util.context) {
                    util.context.$Modal.confirm({
                        title:i18n.tc('l.warn'),
                        content:i18n.tc('l.remark183'),
                        onOk:()=>{
                            util.context.$router.push('/login')
                        },
                        onCancel:()=>{
                            util.context.$router.push('/login')
                        }
                    })
                }
                break;
        }
    },
    onClose() {
        console.log(logTitle, 'on close');
    },
    onError() {
        console.log(logTitle, 'on error');
    },
    send(message) {
        socket.send(message);
        // console.info(logTitle, '发送消息：', message);
    },
    // 添加订阅电梯 列表  单个的装列表L里
    addSubscibeToLift(terminalNames, type) {
        if (typeof terminalNames === 'string') {
            ws.data.terminalNames = [terminalNames];
        } else if (terminalNames) {
            ws.data.terminalNames = terminalNames;
        }
        ws.sendTerminalNames(type);
    },
    /**
     * 发送订阅终端name列表
     */
    sendTerminalNames(type) {
        if (ws.data.terminalNames) {
            if (socket && socket.readyState === 1) {
                if (type == messageTypes.SUBSCRIBE) {
                    ws.sendMessage(messageTypes.SUBSCRIBE, ws.data.terminalNames);
                } else {
                    ws.sendMessage(messageTypes.CANCEL, ws.data.terminalNames);
                }
                ws.data.waiting = false;
            } else {
                ws.data.waiting = true;
                // console.info(logTitle, '等待连接成功后发送订阅列表');
            }
        }
    },
    /**
     * 发送消息
     * @param messageTypes 消息类型
     * @param data
     */
    sendMessage(messageTypes, data) {
        let op = {
            type: messageTypes,
            data: data
        };
        socket.send(typeof op == 'string' ? op : JSON.stringify(op));
        // console.info(logTitle, '发送消息：', op);
    },
    close() {
        if (socket) {
            socket.close();
        }
    }
}

export default ws;

